// extracted by mini-css-extract-plugin
export default {"button":"LoginButton_button__LoT8K","icon":"LoginButton_icon__z3UTX","label":"LoginButton_label__8l86D"};